import * as Sentry from "@sentry/react";

import { SB_STORAGE_KEY } from "consts";

import { AUTH0_LOGOUT_URL } from "../../../consts";

import { queryClient, supabase } from "../../../services";

export const useSignOut = () => {
  return async () => {
    const { data } = await supabase.auth.getSession();
    const isSSO = data.session?.user?.app_metadata?.provider?.startsWith("sso:");

    queryClient.clear();

    const res = await supabase.auth.signOut({ scope: "local" });

    if (res.error) {
      Sentry.captureException(res.error);

      localStorage.removeItem(SB_STORAGE_KEY);
      window.location.reload();
    }

    // auth0 logout
    if (isSSO && process.env.NX_AUTH0_DOMAIN && process.env.NX_AUTH0_CLIENT_ID) {
      window.location.href = AUTH0_LOGOUT_URL;
    }
  };
};
